var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { getDataGridLocaleText } from '../../../../../application/common/constants/get-data-grid-locale-text';
var TechnicianSpecialtiesDatagrid = function (_a) {
    var isFetching = _a.isFetching, rowCount = _a.rowCount, specialities = _a.specialities, specialitiesColumns = _a.specialitiesColumns, paginationModel = _a.paginationModel, filterModel = _a.filterModel, handlePaginationModelChange = _a.handlePaginationModelChange, handleSortModelChange = _a.handleSortModelChange, handleFilterModelChange = _a.handleFilterModelChange, isscreen600900 = _a.isscreen600900, isscreen600900Landscape = _a.isscreen600900Landscape, iscreen9001200 = _a.iscreen9001200, isscreen9001200Landscape = _a.isscreen9001200Landscape;
    return (_jsx(Box, { mt: 2, sx: {
            backgroundColor: 'white',
            borderRadius: '16px',
            boxShadow: '0 24px 48px 0 #919EAB29',
            position: 'relative',
            height: __assign(__assign(__assign({ xs: 'calc(100svh - 325px)', sm: 'calc(100svh - 270px)' }, (isscreen600900 && { sm: 'calc(100svh - 336px)' })), (isscreen600900Landscape && { sm: '400px' })), (isscreen9001200Landscape
                ? { sm: '400px' }
                : iscreen9001200
                    ? { sm: 'calc( 100svh - 247px)' }
                    : {})),
            p: { xs: 0.5, md: 2 }
        }, children: _jsx(DataGrid, { localeText: getDataGridLocaleText(), rows: specialities, rowCount: rowCount, columns: specialitiesColumns, disableColumnSelector: true, rowSelection: false, paginationMode: 'server', paginationModel: paginationModel, onPaginationModelChange: handlePaginationModelChange, pageSizeOptions: [10, 20, 50, 100], filterMode: 'server', filterDebounceMs: 500, filterModel: filterModel, onFilterModelChange: handleFilterModelChange, sortingMode: 'server', onSortModelChange: handleSortModelChange, slotProps: {
                filterPanel: {
                    filterFormProps: {
                        operatorInputProps: {
                            variant: 'standard'
                        },
                        columnInputProps: {
                            variant: 'standard'
                        },
                        valueInputProps: {
                            InputComponentProps: {
                                variant: 'standard'
                            }
                        }
                    }
                }
            }, sx: {
                overflow: 'auto',
                borderWidth: '0px',
                backgroundColor: 'transparent',
                outline: 'none',
                '& .MuiDataGrid-row': { cursor: 'default' },
                '&, [class^=MuiDataGrid]': { border: 'none' },
                '& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeaderTitleContainer': {
                    backgroundColor: '#F4F6F8 !important',
                    border: 'none'
                },
                '& .MuiDataGrid-selectedRowCount': {
                    display: 'none'
                }
            } }) }));
};
export default TechnicianSpecialtiesDatagrid;
